import { withChartLayout } from 'components/common';
import Summary from 'components/features/chart/summary/Summary';

const SummaryPage = withChartLayout('Summary')(Summary);
export default SummaryPage;
